import { FC } from "react";
import Chart from "react-chartjs-2";
import useCategoryPage from "./useCategory";
import Skeleton from "components/atom/Skeleton";

const Category: FC = () => {
  const { chartCategoriesProps, isLoading } = useCategoryPage();
  return (
    <>
      <h2 className="subtitle">
        カテゴリグラフ
        <p className="my-2 is-size-6">
          このグラフでは今のお店の強みと伸びしろを知ることが出来ます。
          <br />
          データは過去1年間のアンケート結果をAIが分析しています。
          <br />
          グラフをクリックするとアンケートを見ることができます。
        </p>
      </h2>

      <div>
        <div>
          {/* FIXME  スマホのときにスクロール可能あるいは２枚グラフ表示 */}
          {/* FIXME  クリック時に顧客セグメントごとの評価を表示 */}
          {isLoading ? (
            <Skeleton height={300} />
          ) : (
            chartCategoriesProps && (
              <div
                className="my-4"
                style={{
                  position: "relative",
                  height: "60vh",
                  marginLeft: "-1.5rem",
                }}
              >
                <Chart {...chartCategoriesProps} id="category-chart" />
              </div>
            )
          )}
        </div>
      </div>
    </>
  );
};

export default Category;
